module.exports = __webpack_public_path__ + "static/media/burgerking.78d85406.svg";